export const generateId = () => {
	return new Date().getTime()
}